import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../styles/AuthPage.css";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import StyledButton from "../../../components/StyledButton.jsx";

class AuthWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: ""
        };
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSubmitClick(e) {
        e.preventDefault();
        this.props.getAuthToken(this.props.ticketId, this.state.email);
    }

    isSubmitButtonEnabled() {
        return !this.props.authTokenLoading;
    }

    getEmailAddressHelperText() {
        if (this.props.authTokenFetchingError) {
            return locales[this.props.language.code].AUTHENTICATION.EMAIL_ADDRESS.ISSUE.INVALID;
        }
    }

    handleBackToTicketSeachClick(e) {
        e.preventDefault();
        this.props.history.push("/tickets/search");
    }

    render() {
        return (
            <div className="flex layout vertical center auth-page-container">
                <section className={`flex layout center auth-page`}>
                    <div className="navigation-panel">
                        <a className="action-button" href={`${process.env.PUBLIC_URL}/tickets/search`} onClick={this.handleBackToTicketSeachClick.bind(this)}>
                            {`${locales[this.props.language.code].TICKET_SEARCH.TITLE}`}
                        </a>
                    </div>
                    <div className="section">
                        <div className="layout horizontal center section-header">
                            <h1 id="title-id" className="title">
                                {locales[this.props.language.code].AUTHENTICATION.TITLE}
                            </h1>
                        </div>
                        <div className="section-body">
                            <div className="flex layout vertical section-body-box">
                                <form className="flex layout vertical" autoComplete="off" onSubmit={this.handleSubmitClick.bind(this)}>
                                    <TextField
                                        autoComplete="off"
                                        error={this.props.authTokenFetchingError ? true : false}
                                        value={this.state.email}
                                        label={locales[this.props.language.code].AUTHENTICATION.EMAIL_ADDRESS.LABEL}
                                        name="email"
                                        onChange={this.handleChange.bind(this)}
                                        className="flex custom-textfield"
                                        variant="outlined"
                                        helperText={this.getEmailAddressHelperText()}
                                        InputLabelProps={{
                                            shrink: true,
                                            htmlFor: "email"
                                        }}
                                        inputProps={{ id: "email" }}
                                    />
                                </form>
                            </div>
                        </div>
                        <div className="section-footer layout horizontal end-justified">
                            <div className="section-footer-box">
                                <div className="button-wrapper">
                                    <StyledButton
                                        id="submit-button-id"
                                        disabled={!this.isSubmitButtonEnabled()}
                                        onClick={this.handleSubmitClick.bind(this)}
                                        variant="contained"
                                    >
                                        {locales[this.props.language.code].BUTTON.SUBMIT.LABEL}
                                    </StyledButton>
                                    {this.props.authTokenLoading && <CircularProgress className="button-progress" size={16} thickness={4} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default withRouter(AuthWindow);
